<script setup>
import { computed, onMounted, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';
import FieldDefinitionsTab from './FieldDefinitionsTab.vue';
import StatusCustomizationTab from './StatusCustomizationTab.vue';
import HorariosTab from './HorariosTab.vue';
import HumanAttentionTab from './HumanAttentionTab.vue';
import ApiPlaygroundTab from './ApiPlaygroundTab.vue';

const { t } = useI18n();
const route = useRoute();
const router = useRouter();
const store = useStore();

const activeTab = ref(route.query.tab || 'fields');

onMounted(() => {
  store.dispatch('painel/fetchSettings');
});

const setTab = key => {
  activeTab.value = key;
  router.replace({ query: { ...route.query, tab: key } });
};

const tabs = computed(() => [
  { key: 'fields', label: t('PAINEL.CONFIGURACOES.TAB_FIELDS') },
  { key: 'status', label: t('PAINEL.CONFIGURACOES.TAB_STATUS') },
  { key: 'hours', label: t('PAINEL.CONFIGURACOES.TAB_HOURS') },
  { key: 'human', label: t('PAINEL.CONFIGURACOES.TAB_HUMAN_ATTENTION') },
  { key: 'api', label: t('PAINEL.CONFIGURACOES.TAB_API') },
]);
</script>

<template>
  <div
    class="flex h-full w-full min-w-0 flex-1 flex-col overflow-hidden bg-n-surface-1"
  >
    <div class="flex-1 overflow-y-auto">
      <div class="flex flex-col gap-6 p-6">
        <header>
          <h1 class="text-xl font-semibold">
            {{ t('PAINEL.CONFIGURACOES.PAGE_TITLE') }}
          </h1>
        </header>

        <nav class="flex gap-0 border-b border-n-strong">
          <button
            v-for="tab in tabs"
            :key="tab.key"
            class="px-4 py-2 text-sm border-b-2"
            :class="
              activeTab === tab.key
                ? 'border-n-brand text-n-slate-12 font-semibold'
                : 'border-transparent text-n-slate-11'
            "
            @click="setTab(tab.key)"
          >
            {{ tab.label }}
          </button>
        </nav>

        <FieldDefinitionsTab v-if="activeTab === 'fields'" />
        <StatusCustomizationTab v-else-if="activeTab === 'status'" />
        <HorariosTab v-else-if="activeTab === 'hours'" />
        <HumanAttentionTab v-else-if="activeTab === 'human'" />
        <ApiPlaygroundTab v-else-if="activeTab === 'api'" />
      </div>
    </div>
  </div>
</template>
